/** Stripe `price.recurring.interval`: the period one plan price actually buys. */
export enum EBillingInterval {
    MONTH = 'month',
    YEAR = 'year',
}

export const billingIntervalAsString = (interval: EBillingInterval | string): string => {
    switch (interval) {
        case EBillingInterval.MONTH:
            return "Mensuel";
        case EBillingInterval.YEAR:
            return "Annuel";
        default:
            return interval.toString();
    }
};

export const billingIntervalAsSuffix = (interval: EBillingInterval | string): string => {
    switch (interval) {
        case EBillingInterval.MONTH:
            return "/mois";
        case EBillingInterval.YEAR:
            return "/an";
        default:
            return '';
    }
};
